import { Box, Text } from "@chakra-ui/react";

type TextLineProps = {
  sm?: boolean;
  icon?: string;
};
const TextLine: React.FC<TextLineProps> = ({ sm, icon, children }) => {
  return (
    <Box
      display="flex"
      color="#71717A"
      alignItems="center"
      fontFamily="Open Sans"
      fontSize={sm ? "sm" : ""}
    >
      {icon && (
        <Box mr="6px" display="flex" alignItems="center">
          <i style={{ color: "#27489B" }} className={icon}></i>
        </Box>
      )}{" "}
      <Text> {children}</Text>
    </Box>
  );
};

type BookClassCardProps = {
  selected?: boolean;
  onClick?: () => void;
};
const BookClassCard: React.FC<BookClassCardProps> = ({
  onClick,
  selected = false,
}) => {
  return (
    <Box
      p={4}
      bg="white"
      role="group"
      cursor="pointer"
      borderRadius="8px"
      transition="all 300ms"
      border={selected ? "2px solid #27489B" : "1px solid #E5E5E5"}
      onClick={onClick}
      _hover={{ borderWidth: "2px", borderColor: "#27489B" }}
    >
      <Text fontFamily="Cairo" fontWeight="700" color="#202020" fontSize="lg">
        Robotics: Beginner
      </Text>
      <TextLine icon="ri-timer-2-line">Mondays 4-5PM (EST)</TextLine>
      <TextLine sm icon="ri-star-s-line">
        Grades 3-5
      </TextLine>
      <TextLine sm icon="ri-group-line">
        Group Class
      </TextLine>
      <TextLine sm icon="ri-calendar-2-line">
        One 1-hour session week
      </TextLine>
      <TextLine sm icon="ri-map-pin-line">
        Virtual
      </TextLine>
    </Box>
  );
};

export { BookClassCard };
